import type { SVGProps } from 'react';

const ShareBand = (props: SVGProps<SVGSVGElement>) => (
  <svg fill='none' height={52} width={52} xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M0 12C0 5.373 5.373 0 12 0h28c6.627 0 12 5.373 12 12v28c0 6.627-5.373 12-12 12H12C5.373 52 0 46.627 0 40V12Z'
      fill='url(#band)'
    />
    <path
      d='M26.004 16.454c-1.126 0-2.2.128-3.224.41v-2.406a4.887 4.887 0 0 0-4.888-4.888c-2.687 0-4.862 2.201-4.862 4.888v14.996c0 7.166 5.809 13 13 13 7.19 0 13-5.809 13-13-.026-7.19-5.835-13-13.026-13Zm0 24.03c-6.09 0-11.055-4.94-11.055-11.055v-14.97a2.943 2.943 0 0 1 2.943-2.944 2.927 2.927 0 0 1 2.943 2.943v14.996a5.171 5.171 0 0 0 5.17 5.17 5.171 5.171 0 0 0 5.169-5.17c0-2.84-2.33-5.17-5.17-5.17a5.188 5.188 0 0 0-3.224 1.127v-2.303a7.143 7.143 0 0 1 10.364 6.372c0 3.94-3.199 7.14-7.14 7.14a7.143 7.143 0 0 1-7.14-7.14V14.458a.972.972 0 1 0-1.945 0v14.996c0 5.016 4.07 9.085 9.085 9.085 5.016 0 9.085-4.07 9.085-9.085 0-5.016-4.07-9.085-9.085-9.085a9.012 9.012 0 0 0-3.224.59v-2.074a11.171 11.171 0 0 1 3.224-.486c6.09 0 11.055 4.939 11.055 11.055 0 6.09-4.939 11.03-11.055 11.03Zm-3.224-11.03a3.211 3.211 0 0 1 3.224-3.224 3.211 3.211 0 0 1 3.225 3.224 3.211 3.211 0 0 1-3.225 3.225 3.227 3.227 0 0 1-3.224-3.225Z'
      fill='#fff'
    />
    <defs>
      <linearGradient gradientUnits='userSpaceOnUse' id='band' x1={26} x2={26} y1={0} y2={52}>
        <stop stopColor='#79F131' />
        <stop offset={1} stopColor='#06A41C' />
      </linearGradient>
    </defs>
  </svg>
);
export default ShareBand;
